export const attachRedirectLinks = ($el) => {
  const links = $el.querySelectorAll('a');
  links.forEach((link) => {
    if (!link.target || link.target === '' || link.target === '_blank') {
      link.target = '_blank';
    }
  });
};
